export default __webpack_public_path__ + "static/media/scene_13.3d240748.mp3";